import { PayloadAction, createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import * as unitService from '../../service/unit.service'
import { Unit } from "../../service/model/unit.model";

export interface UnitState {
    isLoading: boolean;
}

const unitsAdapter = createEntityAdapter({
    selectId: (unit: Unit) => unit.id,
    sortComparer: (a, b) => a.name?.localeCompare(b.name),
  })
  
export const initialState = unitsAdapter.getInitialState({
    isLoading: false,
} as UnitState);

export const fetchUnits = createAsyncThunk<Unit[]>(
    'units/all',
    async (_, {rejectWithValue}) => {
        return unitService.getUnits().catch((errors) => {
            return rejectWithValue(errors);
        })
    }
);

const unitSlice = createSlice({
    name: 'units',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchUnits.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(fetchUnits.fulfilled, (state, action: PayloadAction<Unit[]>) => {
            unitsAdapter.setAll(state, action.payload);
            state.isLoading = false;
        })
        .addCase(fetchUnits.rejected, (state) => {
            state.isLoading = false;
        });
    }
});

export const {
    selectAll: selectUnits,
    selectById: selectUnitById
} = unitsAdapter.getSelectors<RootState>((state) => state.units);

export const selectIsLoading = (state: RootState) => state.units.isLoading;

export default unitSlice.reducer;